import { FormattedMessage } from 'react-intl';

import { TimeZoneChip, TimeZoneChipZone } from '@/components/ui/time-zone-chip';

/** The All Campaigns count bar's note that each campaign counts in its opening's zone. */
export function CampaignsTimeZoneChip() {
  return (
    <TimeZoneChip
      withInfoIcon
      tooltipTitle={
        <FormattedMessage
          defaultMessage="Why not one time zone for everything?"
          description="Title of the tooltip on the All Campaigns time zone chip"
        />
      }
      tooltipBody={
        <>
          <p>
            <FormattedMessage
              defaultMessage="Each campaign runs in its opening’s time zone. The totals aggregate every campaign over the same window, so a total never changes depending on who opens this page or where they are."
              description="Tooltip on the All Campaigns time zone chip: why each campaign counts in its opening's time zone"
            />
          </p>
          <p>
            <FormattedMessage
              defaultMessage="For example, Oct 1–31 counts Oct 1–31 in America/New_York for a campaign on a Tampa opening and Oct 1–31 in America/Los_Angeles for one on a Reno opening. The total adds both."
              description="Tooltip on the All Campaigns time zone chip: an example of two campaigns in different time zones"
            />
          </p>
        </>
      }
    >
      <FormattedMessage
        defaultMessage="Each campaign counts in <zone>its opening’s time zone</zone>"
        description="Chip in the All Campaigns count bar: every campaign counts in its opening's time zone"
        values={{
          zone: chunks => <TimeZoneChipZone>{chunks}</TimeZoneChipZone>,
        }}
      />
    </TimeZoneChip>
  );
}
